module.exports = __webpack_public_path__ + "static/p1-97954897853ebf9c6e37d7ea72d1f799.jpg";